var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 8.66699C8.36823 8.66699 8.66671 8.36851 8.66671 8.00033C8.66671 7.63214 8.36823 7.33366 8.00004 7.33366C7.63185 7.33366 7.33337 7.63214 7.33337 8.00033C7.33337 8.36851 7.63185 8.66699 8.00004 8.66699Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 4.00033C8.36823 4.00033 8.66671 3.70185 8.66671 3.33366C8.66671 2.96547 8.36823 2.66699 8.00004 2.66699C7.63185 2.66699 7.33337 2.96547 7.33337 3.33366C7.33337 3.70185 7.63185 4.00033 8.00004 4.00033Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 13.3337C8.36823 13.3337 8.66671 13.0352 8.66671 12.667C8.66671 12.2988 8.36823 12.0003 8.00004 12.0003C7.63185 12.0003 7.33337 12.2988 7.33337 12.667C7.33337 13.0352 7.63185 13.3337 8.00004 13.3337Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDotsVertical);
export default __webpack_public_path__ + "static/media/IconDotsVertical.7677ee487ae2391e2a9cfe55ed9144eb.svg";
export { ForwardRef as ReactComponent };